module.exports = __webpack_public_path__ + "img/P44-en.07ce5716.png";